<div class="container">
  <div class="region-title mt-2">
    <div>Recommendations in {{ selectedMemberRegion }}</div>
    <button class="my-button-3" (click)="openAddRecommendationForm()"><i class="fa fa-plus"></i></button>
  </div>
  <div class="cats-count w-100">
    <div class="card-sub-cate" (click)="selectAll()" [ngClass]="{ active: areAllSelected }">
      <div class="card-sub-cate__title mb-0">All</div>
    </div>
    <ng-container *ngFor="let cat of catsCount">
      <div *ngIf="cat.recommendationCounts && cat.name?.trim()" (click)="selectcat(cat)" [ngClass]="{ active: cat.selected }" class="card-sub-cate">
        <div class="product-count">( {{ cat.recommendationCounts || 0 }} )</div>
        <div class="card-sub-cate__title">
          {{ cat.name | titlecase }}
        </div>
      </div>
    </ng-container>
  </div>
  <div style="position: relative">
    <!-- <div style="position: absolute; right: 0px; top: 2.5rem">
      <button class="my-button-3" (click)="openAddRecommendationForm()"><i class="fa fa-plus"></i> Recommend</button>
    </div> -->
    <app-my-tabs [tabs]="tabs" (tabChange)="onTabChange($event)">
      <div tab1 class="recomms">
        <div *ngFor="let recomm of myRecommendations" class="recomm-card">
          <div style="position: relative">
            <button class="controls p-1" (click)="recomm.isPopupOpen = !recomm.isPopupOpen" style="font-size: 1.1rem">
              <i class="fa-solid fa-ellipsis-v text-dark"></i>
              <div class="controls-dropdown" *ngIf="recomm.isPopupOpen">
                <button (click)="editRecommendation(recomm)"><i class="fa fa-pen mr-2"></i> <span>Edit</span></button>
                <button (click)="deleteRecomm(recomm)"><i class="fa fa-trash mr-2"></i> <span style="color: purple">Delete</span></button>
                <button *ngIf="isUserAdmin" (click)="promoteRecommendationToProduct(recomm)"><i class="fa fa-check mr-2"></i> Promote</button>
              </div>
            </button>

            <div class="name">
              {{ recomm.nameOfServiceProvider }}
            </div>
            <div>
              {{ recomm.company }}
            </div>
            <div class="selling-points">
              <div class="message" *ngIf="recomm.uniqueSellingPointOne">
                <i class="fa-solid fa-arrow-right mr-1"></i>
                <span>{{ recomm.uniqueSellingPointOne | slice : 0 : 50 }}</span>
              </div>

              <div class="message" *ngIf="recomm.uniqueSellingPointTwo">
                <i class="fa-solid fa-arrow-right mr-1"></i>
                <span>{{ recomm.uniqueSellingPointTwo | slice : 0 : 50 }}</span>
              </div>
            </div>
          </div>

          <div>
            <div class="company">
              <img *ngIf="recomm.imageLocation" loading="lazy" src="{{ imageUrl + recomm.imageLocation }}" alt="" />
              <span *ngIf="!recomm.imageLocation" style="width: 1px"></span>
              <div class="number">
                {{ recomm.phone }}
              </div>
            </div>

            <div class="recomm-card__footer">
              <button (click)="like(recomm)">{{ recomm.likeCounts }} <i class="fa fa-thumbs-up"></i></button>
            </div>
          </div>
        </div>
      </div>
      <div tab0 class="recomms">
       
        <ng-container >
              
              <div *ngFor="let recomm of recommendations" class="recomm-card">
                <div>
                  <div class="name">
                    {{ recomm.nameOfServiceProvider }}
                  </div>
                  <div>
                    {{ recomm.company }}
                  </div>
                  <div class="selling-points">
                    <div class="message" *ngIf="recomm.uniqueSellingPointOne">
                      <i class="fa-solid fa-arrow-right mr-1"></i>
                      <span>{{ recomm.uniqueSellingPointOne | slice : 0 : 50 }}</span>
                    </div>

                    <div class="message" *ngIf="recomm.uniqueSellingPointTwo">
                      <i class="fa-solid fa-arrow-right mr-1"></i>
                      <span>{{ recomm.uniqueSellingPointTwo | slice : 0 : 50 }}</span>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="company">
                    <img *ngIf="recomm.imageLocation" loading="lazy" src="{{ imageUrl + recomm.imageLocation }}" alt="" />
                    <span *ngIf="!recomm.imageLocation" style="width: 1px"></span>
                    <div class="number">
                      {{ recomm.phone }}
                    </div>
                  </div>

                  <div class="recomm-card__footer">
                    <button (click)="like(recomm)">{{ recomm.likeCounts }} <i class="fa fa-thumbs-up"></i></button>
                  </div>
                </div>
              </div>
            </ng-container>
         </div>
    </app-my-tabs>
  </div>
</div>

<app-add-shop  #AddShop [enableMemberShop]="true"></app-add-shop>
